const tbTokenEnc =
	'cC5leUoxSWpvZ0ltVmxPRFJsT0dabExXWmlOR1l0TkRBd05DMWhNakl3TFdVMlpqazFOREJqTURjM1pDSXNJQ0pwWkNJNklDSmtNMlF3TjJVNE1pMWtPRE5rTFRReU1qUXRZV1E1WWkweFlUSmlOR00zTkRaa04yRWlMQ0FpYUc5emRDSTZJQ0oxYzE5bFlYTjBJbjAudEVUb19lQzU4NzNibzlEOHYtMF9MNkZpWHBic1NvRkotWTVsSlNWREFQQQ==';

export function reportMetric(metric: { event_key: string; created_ms: number; data: any; metric: string; value: number; url: string }) {
	console.log('Received metric', metric);
	if (/localhost|127\.0\.0\.1|staging/.test(window.location.hostname)) {
		console.log('Skipping metric sending on dev env');
		return;
	}
	metric.data.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	metric.data = JSON.stringify(metric.data);
	fetch('https://api.us-east.tinybird.co/v0/events?name=overlay_metrics', {
		method: 'POST',
		body: JSON.stringify(metric),
		headers: {
			Authorization:
				// the token is base64 as a little "protection"...
				'Bearer ' + atob(tbTokenEnc),
			'Content-Type': 'application/json',
		},
	}).catch((e) => {
		console.error('Error sending metric', e);
	});
}
